import React from 'react';

import { Advantages } from '../../components/home/Advantages';
import { Carousel } from '../../components/home/Carousel';
import ContactForm from '../../components/home/ContactForm';
import { ContactInfo } from '../../components/home/ContactInfo';
import Crew from '../../components/home/Crew';
import HomeGallery from '../../components/home/HomeGallery';
import { Map } from '../../components/home/map/Map';
import Slogan from '../../components/home/Slogan';
import FacebookHome from '../../components/home/Socials';
import { Section } from '../../components/Section';
import { SEO } from '../../components/Seo';
import { PageProps } from '../../interfaces/PageProps';
import { decodeUri } from '../../utils/DecodeUri';
import { getKindergartenByPathname } from '../../utils/GetKindergartenByPathname';
import { theme } from '../../utils/Theme';
import withLocation from '../../utils/WithLocation';

const Home = (props: PageProps) => (
  <>
    <link rel="dns-prefetch" href="https://maps.gstatic.com" />
    <SEO title={decodeUri(getKindergartenByPathname(props.location.pathname))} />
    <Carousel location={props.location}></Carousel>
    <Section backgroundColor={theme.colors.creamy}>
      <Slogan kindergartenName={props.kindergartenName}></Slogan>
    </Section>
    <Section>
      <Advantages location={props.location}></Advantages>
    </Section>
    <Section backgroundColor={theme.colors.creamy}>
      <Crew location={props.location} />
    </Section>
    <Section>
      <HomeGallery location={props.location}></HomeGallery>
    </Section>
    <ContactInfo location={props.location}></ContactInfo>
    <Map location={props.location}></Map>
    <Section backgroundColor={theme.colors.white}>
      <ContactForm></ContactForm>
      <FacebookHome location={props.location}></FacebookHome>
    </Section>
  </>
);

export default withLocation(Home);
